import { Link } from 'react-router-dom'
import styled from 'styled-components'
import colors from 'utils/styling/colors'

export const PageWrap = styled.main`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 40px 48px 80px 48px;
  max-width: 1200px;
  margin: 0 auto;
`

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  color: ${colors('almostBlack')};
`

export const Subtitle = styled.p`
  font-size: 14px;
  margin: 0;
  color: ${colors('gray2')};
`

export const Group = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const GroupHeading = styled.h2`
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: ${colors('gray1')};
`

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
`

export const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 20px;
  border: 1px solid ${colors('gray4')};
  border-radius: 8px;
  background: ${colors('white')};
  text-decoration: none;
  transition:
    border-color 0.15s ease,
    background 0.15s ease;

  &:hover {
    border-color: ${colors('brand')};
    background: ${colors('palePrimary')};
  }

  &:focus-visible {
    outline: 2px solid ${colors('brand')};
    outline-offset: 2px;
  }
`

export const CardLabel = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${colors('almostBlack')};
`

export const CardDescription = styled.span`
  font-size: 14px;
  line-height: 1.4;
  color: ${colors('gray2')};
`
